// karmic-grove-product.js
// Wrapped in DOMContentLoaded so it runs AFTER the page HTML is ready.

document.addEventListener('DOMContentLoaded', function() {

  // ── PLAN DATA ──────────────────────────────────────────
  // Read location from the product-wrap data attribute set by the Liquid section
  var productWrap = document.querySelector('[data-location]');
  var LOCATION = productWrap ? productWrap.getAttribute('data-location') : 'United States';
  console.log('[KG] Location:', LOCATION);

  // Plans data — prices differ by location, loaded from radio data attributes
  var plans = {
    seed:   { price:9,     day:'0.30', trees:1,  name:'Seed',   feats:['cert'] },
    grove:  { price:24,    day:'0.80', trees:3,  name:'Grove',  feats:['cert','gps','env'] },
    forest: { price:38,    day:'1.27', trees:5,  name:'Forest', feats:['cert','gps','env'] },
    legacy: { price:73,    day:'2.43', trees:10, name:'Legacy', feats:['cert','gps','env','social'] }
  };
  // Read the initially checked plan from the DOM (works for both US and India)
  var checkedRadio = document.querySelector('input[name="plan"]:checked');
  var currentPlan = checkedRadio ? checkedRadio.value : 'grove';

  // ── VARIANT IDs — read from Liquid-injected JSON ───────
  // Shopify renders real variant IDs into #kg-variant-data at page load.
  var VARIANT_ID_MAP = {};
  var variantDataEl = document.getElementById('kg-variant-data');
  if (variantDataEl) {
    try {
      var variantData = JSON.parse(variantDataEl.textContent);
      variantData.forEach(function(v) {
        VARIANT_ID_MAP[v.title.toLowerCase()] = v.id;
      });
      console.log('[KG] Variant IDs loaded:', VARIANT_ID_MAP);
    } catch(e) {
      console.error('[KG] Failed to parse variant data:', e);
    }
  } else {
    console.warn('[KG] #kg-variant-data not found — are you on a Shopify product page?');
  }

  // ── HELPER: update pills ───────────────────────────────
  function setPill(id, on) {
    var el = document.getElementById(id);
    if (!el) return;
    el.classList.toggle('pill-on',  on);
    el.classList.toggle('pill-off', !on);
  }

  // ── HELPER: update all UI for selected plan ────────────
  function syncPlanUI(planKey) {
    // Read price/day/trees from the radio's data attributes — works for both US and India
    var radio = document.querySelector('input[name="plan"][value="' + planKey + '"]');
    var p = plans[planKey] || {};
    if (radio) {
      p = {
        price: parseFloat(radio.getAttribute('data-price')) || p.price,
        day:   radio.getAttribute('data-day')   || p.day,
        trees: parseInt(radio.getAttribute('data-trees')) || p.trees,
        name:  radio.getAttribute('data-name')  || p.name || planKey,
        feats: (radio.getAttribute('data-feats') || 'cert').split(',')
      };
    }
    if (!p.price) return;

    // Price + per-day
    var priceEl = document.getElementById('price-display');
    if (priceEl) priceEl.innerHTML = '<sup>$</sup>' + p.price;
    var dayEl = document.getElementById('price-day');
    if (dayEl) dayEl.textContent = '$' + p.day + ' per day';

    // ATC button price
    var atcPriceEl = document.getElementById('atc-price');
    if (atcPriceEl) atcPriceEl.textContent = '$' + p.price;

    // Image overlay — plan badge
    var planNameEl = document.getElementById('svg-plan-name');
    if (planNameEl) planNameEl.textContent = p.name.toUpperCase() + ' PLAN';
    var planTreesEl = document.getElementById('svg-plan-trees');
    if (planTreesEl) planTreesEl.textContent = p.trees + ' tree' + (p.trees > 1 ? 's' : '') + ' / month';

    // Image overlay — coin
    var coinEl = document.getElementById('svg-coin-amount');
    if (coinEl) coinEl.textContent = '$' + p.day;

    // Below-image labels
    var visNameEl = document.getElementById('vis-plan-name');
    if (visNameEl) visNameEl.textContent = p.name + ' Plan';
    var visSubEl = document.getElementById('vis-plan-sub');
    if (visSubEl) visSubEl.textContent = p.trees + ' tree' + (p.trees > 1 ? 's' : '') + ' · United States';

    // Feature pills
    var has = function(f) { return p.feats.indexOf(f) !== -1; };
    setPill('pill-cert',   has('cert'));
    setPill('pill-gps',    has('gps'));
    setPill('pill-env',    has('env'));
    setPill('pill-social', has('social'));
  }

  // ── PLAN RADIO LISTENERS ───────────────────────────────
  var radios = document.querySelectorAll('input[name="plan"]');
  if (radios.length === 0) {
    console.warn('[KG] No plan radio inputs found — check input[name="plan"] exists in the HTML');
  }
  radios.forEach(function(r) {
    r.addEventListener('change', function() {
      currentPlan = r.value;
      syncPlanUI(currentPlan);
    });
  });

  // Run once on load to sync UI to default checked plan
  syncPlanUI(currentPlan);

  // ── GIFT TOGGLE ────────────────────────────────────────
  window.toggleGift = function(cb) {
    var giftSection = document.getElementById('gift-sender-section');
    var certDesc    = document.getElementById('cert-desc');
    var nameLabel   = document.getElementById('cert-name-label');
    var emailLabel  = document.getElementById('cert-email-label');
    var certNameEl  = document.getElementById('cert-name');
    var certEmailEl = document.getElementById('cert-email');
    if (cb.checked) {
      if (giftSection)  giftSection.classList.add('visible');
      if (certDesc)     certDesc.textContent   = "Enter the recipient's details. The certificate will be personalised with their name and emailed to them.";
      if (nameLabel)    nameLabel.textContent  = "Recipient's name (on certificate)";
      if (emailLabel)   emailLabel.textContent = "Recipient's email (certificate sent here)";
      if (certNameEl)   certNameEl.placeholder  = 'e.g. Priya Sharma';
      if (certEmailEl)  certEmailEl.placeholder = 'e.g. priya@example.com';
    } else {
      if (giftSection)  giftSection.classList.remove('visible');
      if (certDesc)     certDesc.textContent   = 'Your digital planting certificate will be personalised with this name and emailed automatically after purchase.';
      if (nameLabel)    nameLabel.textContent  = 'Name on certificate';
      if (emailLabel)   emailLabel.textContent = 'Email to send certificate to';
      if (certNameEl)   certNameEl.placeholder  = 'e.g. Sarah Johnson';
      if (certEmailEl)  certEmailEl.placeholder = 'e.g. sarah@example.com';
      var sn = document.getElementById('sender-name');    if (sn) sn.value = '';
      var gm = document.getElementById('gift-message');   if (gm) gm.value = '';
    }
  };

  // ── CERTIFICATE SVG BUILDER ────────────────────────────
  function buildCertSVG(name, plan, location, trees) {
    var d = new Date().toLocaleDateString('en-US', {year:'numeric', month:'long', day:'numeric'});
    var emojis = '';
    for (var i = 0; i < Math.min(trees, 10); i++) emojis += '🌲';
    return '<svg viewBox="0 0 800 566" xmlns="http://www.w3.org/2000/svg" font-family="Georgia,serif">'
      + '<defs>'
      + '<linearGradient id="cb" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#E8F9F0"/><stop offset="100%" stop-color="#C8EDD8"/></linearGradient>'
      + '<linearGradient id="ch" x1="0" y1="0" x2="1" y2="0"><stop offset="0%" stop-color="#2C7B4F"/><stop offset="50%" stop-color="#3a9060"/><stop offset="100%" stop-color="#2C7B4F"/></linearGradient>'
      + '</defs>'
      + '<rect width="800" height="566" fill="url(#cb)"/>'
      + '<rect x="12" y="12" width="776" height="542" rx="4" fill="none" stroke="#023D8B" stroke-width="1.5" opacity=".35"/>'
      + '<rect x="22" y="22" width="756" height="522" rx="3" fill="none" stroke="#023D8B" stroke-width=".75" stroke-dasharray="5,5" opacity=".2"/>'
      + '<rect x="12" y="12" width="776" height="78" rx="4" fill="url(#ch)"/>'
      + '<rect x="12" y="76" width="776" height="14" fill="#2C7B4F"/>'
      + '<rect x="12" y="476" width="776" height="66" rx="4" fill="url(#ch)"/>'
      + '<rect x="12" y="476" width="776" height="14" fill="#2C7B4F"/>'
      + '<text x="400" y="52" text-anchor="middle" font-size="22" fill="#EFECEC" letter-spacing="8">KARMIC AVSAR</text>'
      + '<text x="400" y="72" text-anchor="middle" font-size="10" fill="rgba(217,243,229,.65)" letter-spacing="4">karmicavsar.com</text>'
      + '<text x="36"  y="126" font-size="18" fill="#2C7B4F" opacity=".45">🌿</text>'
      + '<text x="764" y="126" font-size="18" fill="#2C7B4F" opacity=".45" text-anchor="end">🌿</text>'
      + '<text x="36"  y="466" font-size="18" fill="#2C7B4F" opacity=".45">🌿</text>'
      + '<text x="764" y="466" font-size="18" fill="#2C7B4F" opacity=".45" text-anchor="end">🌿</text>'
      + '<text x="400" y="142" text-anchor="middle" font-size="11" fill="#023D8B" letter-spacing="7" opacity=".5">CERTIFICATE OF</text>'
      + '<text x="400" y="175" text-anchor="middle" font-size="38" font-weight="300" fill="#023D8B">Tree Planting</text>'
      + '<line x1="180" y1="192" x2="620" y2="192" stroke="#2C7B4F" stroke-width="1" opacity=".4"/>'
      + '<text x="400" y="224" text-anchor="middle" font-size="13" fill="#023D8B" opacity=".55" letter-spacing="2">This certifies that</text>'
      + '<text x="400" y="282" text-anchor="middle" font-size="48" fill="#023D8B">' + (name || 'Your Name') + '</text>'
      + '<line x1="120" y1="295" x2="680" y2="295" stroke="#2C7B4F" stroke-width="1.5" opacity=".5"/>'
      + '<text x="400" y="328" text-anchor="middle" font-size="14" fill="#023D8B" opacity=".6">has planted</text>'
      + '<text x="400" y="365" text-anchor="middle" font-size="20" fill="#2C7B4F">' + trees + ' tree' + (trees > 1 ? 's' : '') + ' in ' + location + ' \u00B7 ' + plan + ' Plan</text>'
      + '<text x="400" y="400" text-anchor="middle" font-size="22">' + emojis + '</text>'
      + '<text x="400" y="432" text-anchor="middle" font-size="12" fill="#023D8B" opacity=".45">Planting commenced ' + d + ' \u00B7 In partnership with ReThink</text>'
      + '<text x="400" y="503" text-anchor="middle" font-size="11" fill="#EFECEC" opacity=".85" letter-spacing="3">GOOD KARMA. BY CHOICE.</text>'
      + '<text x="400" y="522" text-anchor="middle" font-size="9" fill="rgba(239,236,236,.5)" letter-spacing="1">karmicavsar.com</text>'
      + '</svg>';
  }

  // ── PREVIEW CERT ───────────────────────────────────────
  window.previewCert = function() {
    var nameEl = document.getElementById('cert-name');
    var name = nameEl ? nameEl.value.trim() : '';
    var p = plans[currentPlan];
    var wrap = document.getElementById('cert-svg-wrap');
    if (wrap) wrap.innerHTML = buildCertSVG(name || 'Your Name Here', p.name, LOCATION, p.trees);
    var modal = document.getElementById('cert-modal');
    if (modal) modal.classList.add('open');
    document.body.style.overflow = 'hidden';
  };

  window.closeCert = function() {
    var modal = document.getElementById('cert-modal');
    if (modal) modal.classList.remove('open');
    document.body.style.overflow = '';
  };

  window.downloadCert = function() {
    var svg = document.querySelector('#cert-svg-wrap svg');
    if (!svg) return;
    var data = new XMLSerializer().serializeToString(svg);
    var blob = new Blob([data], {type: 'image/svg+xml'});
    var url  = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = 'karmic-avsar-certificate.svg';
    a.click();
    URL.revokeObjectURL(url);
  };

  // ── ADD TO CART ────────────────────────────────────────
  window.addToCart = function() {
    var certNameEl  = document.getElementById('cert-name');
    var certEmailEl = document.getElementById('cert-email');
    var isGiftEl    = document.getElementById('is-gift');
    var certName    = certNameEl  ? certNameEl.value.trim()  : '';
    var certEmail   = certEmailEl ? certEmailEl.value.trim() : '';
    var isGift      = isGiftEl    ? isGiftEl.checked         : false;
    var senderNameEl  = document.getElementById('sender-name');
    var giftMessageEl = document.getElementById('gift-message');
    var senderName    = (isGift && senderNameEl)  ? senderNameEl.value.trim()  : '';
    var giftMessage   = (isGift && giftMessageEl) ? giftMessageEl.value.trim() : '';

    // Validate
    if (!certName) {
      alert('Please enter the name for the certificate.');
      if (certNameEl) certNameEl.focus();
      return;
    }
    if (!certEmail) {
      alert('Please enter the email address.');
      if (certEmailEl) certEmailEl.focus();
      return;
    }
    if (isGift && !senderName) {
      alert('Please enter your name in the gift sender section.');
      if (senderNameEl) senderNameEl.focus();
      return;
    }

    // Check variant ID
    var variantId = VARIANT_ID_MAP[currentPlan];
    if (!variantId) {
      console.error('[KG] No variant ID for plan:', currentPlan, '— VARIANT_ID_MAP:', VARIANT_ID_MAP);
      alert('Setup issue: variant ID missing for the ' + currentPlan + ' plan.\n\nOpen browser console (F12) and look for "[KG] Variant IDs loaded" to see what was found.\n\nMake sure your Shopify variant titles are exactly: Seed, Grove, Forest, Legacy');
      return;
    }

    var props = {
      'Certificate Name':  certName,
      'Certificate Email': certEmail,
      'Plan':              plans[currentPlan].name,
      'Location':          LOCATION,
      'Trees per month':   plans[currentPlan].trees,
      'Is Gift':           isGift ? 'Yes' : 'No'
    };
    if (isGift && senderName)  props['Sender Name']  = senderName;
    if (isGift && giftMessage) props['Gift Message'] = giftMessage;

    var btn = document.getElementById('kg-atc-btn');
    var origLabel = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    console.log('[KG] Adding to cart — variant:', variantId, 'plan:', currentPlan, 'props:', props);

    fetch('/cart/add.js', {
      method:  'POST',
      headers: {'Content-Type': 'application/json'},
      body:    JSON.stringify({ id: variantId, quantity: 1, properties: props })
    })
    .then(function(r) {
      return r.json().then(function(data) {
        if (!r.ok) {
          throw new Error((data.description || data.message || JSON.stringify(data)) + ' (HTTP ' + r.status + ')');
        }
        return data;
      });
    })
    .then(function() {
      window.location.href = '/cart';
    })
    .catch(function(err) {
      console.error('[KG] Cart error:', err);
      if (btn) { btn.disabled = false; btn.innerHTML = origLabel; }
      alert('Could not add to cart:\n\n' + err.message + '\n\nCheck browser console (F12) for details.');
    });
  };

  // ── ACCORDION ──────────────────────────────────────────
  window.accord = function(el) {
    var a = el.nextElementSibling;
    var open = a.classList.contains('open');
    document.querySelectorAll('.accord-a').forEach(function(x) { x.classList.remove('open'); });
    document.querySelectorAll('.accord-q').forEach(function(x) { x.classList.remove('open'); });
    if (!open) { a.classList.add('open'); el.classList.add('open'); }
  };

  // Close modal on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') window.closeCert();
  });

  console.log('[KG] Karmic Grove product page initialised. Plan:', currentPlan, 'Variants:', VARIANT_ID_MAP);

}); // end DOMContentLoaded